import { Avatar, Button, Dropdown, Tag, Typography } from "antd";
import { OrganisationDto } from "dtos/organisation.dto";
import { T_MongoId } from "types/_utils.types";
import { ReactNode, useMemo } from "react";

interface OrgSelectorProps {
  organisations: OrganisationDto[];
  selected?: T_MongoId;
  onChange?: (org: OrganisationDto) => unknown;
  checkDisabled?: (org: OrganisationDto) => boolean;
  extra?: (org: OrganisationDto) => ReactNode;
}

export const OrgSelector = ({ organisations, selected, onChange, checkDisabled, extra }: OrgSelectorProps) => {
  const selectedOrg = useMemo(() => {
    if (!selected) return undefined;
    const found = organisations.find((org) => {
      return org._id === selected || org.code === selected;
    });

    return found;
  }, [organisations, selected]);

  const orgCode = selectedOrg?.code ?? "";

  return (
    <Dropdown
      trigger={["click"]}
      menu={{
        selectedKeys: [orgCode],
        items: [
          ...organisations.map((org) => ({
            key: org.code,
            disabled: checkDisabled ? checkDisabled(org) : false,
            className: orgCode === org.code ? "bg-indigo-50" : "",
            style: {
              borderWidth: 2,
              borderStyle: "solid",
              borderColor: orgCode === org.code ? "#e0e7ff" : "transparent",
              opacity: checkDisabled?.(org) === true ? 0.6 : 1,
            },
            onClick() {
              onChange?.(org);
            },
            label: (
              <div className="flex items-center gap-2 w-full">
                <div className={`flex items-center gap-3`}>
                  <div className="flex items-center gap-3 bg-transparent min-w-36 border-none outline-none">
                    <Avatar className={`uppercase font-semibold`} src={org.meta?.favicon}>
                      {org.name.charAt(0).toUpperCase()}
                    </Avatar>
                    <div className="flex flex-col items-start">
                      <Typography.Text type="secondary" className="text-xs">
                        {org.name}
                      </Typography.Text>
                    </div>
                    {extra ? extra(org) : null}
                  </div>
                </div>
              </div>
            ),
          })),
        ],
      }}
    >
      <Button type="default" size="middle" className="">
        <div className="flex items-center gap-3 ">
          <Avatar size={"small"} className={`uppercase font-semibold`} src={selectedOrg?.meta?.favicon}>
            {selectedOrg?.name?.charAt(0).toUpperCase()}
          </Avatar>
          <div className="flex flex-col items-start">
            <Typography.Text type="secondary" className="text-xs">
              {selectedOrg?.name ?? selected}
            </Typography.Text>
          </div>
        </div>
      </Button>
    </Dropdown>
  );
};
